// extracted by mini-css-extract-plugin
export default {"switchField":"styles_switchField__T-X+g","disabled":"styles_disabled__d7RFm"};